var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullScreenDarkOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 37,
    viewBox: "0 0 46 37",
    fill: "None",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2689_2053)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2689_2053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2158 0.757351L37.91 0.757352V10.1979H45.7969V13.7788H34.2158V0.757351Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2689_2053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.581 0.757351L7.88683 0.757352V10.1979H0V13.7788H11.581V0.757351Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2689_2053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.581 36.3891L7.88683 36.3891V26.9485H0V23.3677H11.581V36.3891Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2689_2053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2158 23.7868H45.9707V27.3676L38.0379 27.3676L38.0381 36.4163H34.216C34.216 31.4841 34.2159 28.7189 34.2158 23.7868Z",
    fill: "#000000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2689_2053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.9707,
    height: 35.659,
    fill: "white",
    transform: "translate(0 0.757324)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2689_2053"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2158 0.757324H45.7969V13.7788H37.2158C35.559 13.7788 34.2158 12.4356 34.2158 10.7788V0.757324Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2689_2053"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.757324H11.581V10.7788C11.581 12.4356 10.2379 13.7788 8.58105 13.7788H0V0.757324Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2689_2053"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.3677H8.58105C10.2379 23.3677 11.581 24.7108 11.581 26.3677V36.3891H0V23.3677Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2689_2053"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2158 26.7869C34.2158 25.13 35.559 23.7869 37.2158 23.7869H45.9707V36.4164H34.2158V26.7869Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenDarkOut);
export default __webpack_public_path__ + "static/media/FullScreenDarkOut.27838f122978951327b03bf42a4a5318.svg";
export { ForwardRef as ReactComponent };